import { createAction } from '@ngrx/store';

// Call this function when wanting to hand over all unsubmitted forms.
export const handOverUnsubmittedForms = createAction('[Forms] Hand over unsubmitted forms');

// action called after all forms have been handed over
export const handOverUnsubmittedFormsSuccess = createAction('[Forms] Hand over unsubmitted forms success');
